// @flow
import React from 'react';

import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';
import { Text, type TextProps } from 'Components/frameworks/text/Text.jsx';

type Props = {
  ...$Exact<TextProps>,
  id?: string,
};

export function TextLine({ id, ...props }: Props) {
  return (
    <SiteContainer id={id} className="Line">
      <Text {...props} />
    </SiteContainer>
  );
}
